module.exports = __webpack_public_path__ + "static/media/munich_mac.d.32f85014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/munich_mac.d.jpg
// module id = 464
// module chunks = 0